<script>
import InfoCardForm from "@/views/menu/info-card-page/info-card/infoCardForm";
import Component, { mixins } from "vue-class-component";

@Component({
  inject: {
    infoCardPageService: "infoCardPageService",
    infoBoxService: "infoBoxService",
    toastService: "toastService"
  }
})
export default class InfoCardClone extends mixins(InfoCardForm) {
  formId = "clone-info-card-form";
  infoCardPages = [];

  get fieldColumns() {
    return 2;
  }

  get languages(){
    if (
      this.infoCardPages.length == 0 ||
      this.model.idInfoCardPage === null ||
      this.model.idInfoCardPage === undefined ||
      this.events === undefined ||
      this.events === null
    )
      return [];
    const event = this.events.filter((e) => e.value == this.infoCardPages.find(x => x.id == this.model.idInfoCardPage)?.idEvent)[0];
    if (event != undefined) return event.languages;
    return [];
  }

  get decoratedElements() {
    return this.insertBefore(
        this.elements,
        {
            id: "idInfoCardPage",
            label: this.translations.labels.infoCard_cloneForm_destinationIdInfoCardPage,
            type: "select",
            items: this.infoCardPagesOptions,
            required: true,
        }
    );
  }

  get infoCardPagesOptions() {
    return this.infoCardPages.map(x =>
    {
      return {
        value: x.id,
        label: x.code
        };
    });
  }

  get actions() {
    return [
      {
        id: "save",
        type: "submit",
        text: this.translations.labels.button_save,
        leftIcon: "mdi-content-save-outline",
        handle: this.save
      }
    ];
  }

  async save(action, passesValidation) {
    this.errors = [];
    if (!passesValidation) {
      return;
    }
    try {
      await this.infoCardPageService.cloneCard(this.$route.params.idInfoCardPage, this.$route.params.id, this.model);
      this.$router.push(`/info-card-pages/${this.model.idInfoCardPage}/cards/list`);
      this.toastService.success(this.translations.success.infoCard_cloned);
    } catch (error) {
      this.errors = this.formatApiErrors(error);
    }
  }

  getFormTitle () {
    return this.translations.pageTitles.infoCards_clone;
  }

  async afterCreate () {
    this.model = await this.infoCardPageService.readCard(this.$route.params.idInfoCardPage, this.$route.params.id);

    if (this.model.idInfoBox !== null) {
      this.model.infoBoxData = await this.infoBoxService.read(this.model.idInfoBox);
      this.model.infoBoxData.enableInfoBox = this.model.infoBoxData.isEnabled;
    } else {
      this.model.infoBoxData = {
        enableInfoBox: false,
        code: "",
        width: null,
        height: null,
        x: null,
        y: null,
        localizations: [],
      };
    }

    this.model.code = null;
    this.model.id = null;

    this.infoCardPages = await this.infoCardPageService.list();

    this.isReady = true;
  }
}
</script>
